import { Injectable } from "@angular/core";
import { Notification } from "@shared/entities/notification";
import { ApiService } from "@shared/services/api/api.service";
import { Observable, shareReplay } from "rxjs";

@Injectable({
	providedIn: 'root',
})
export class NotificationsService extends ApiService<Notification> {
	notifications$: Observable<Notification[]> = this.findAll().pipe(shareReplay(1));

	constructor() {
		const masterUrl = '/notifications';
		const detailUrl = '/notifications/{id}';
		super(Notification, masterUrl, detailUrl, 'notifications');
	}

	getNotifications(): Observable<Notification[]> {
		return this.notifications$;
	}
}